
/* injects from baggage-loader */

'use strict';

import ManageProjectComponent from './manageproject.component';

const ManageProjectPageModule = angular.module('manage-project-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('manageproject', {
        url: '/manage-project/{id}',
        component: 'manageProject',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('manageProject', new ManageProjectComponent());

export default ManageProjectPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/manageProject/manageproject.module.js